
import React from 'react';

const TermsOfUseContent = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Termos de Uso – Justiçai</h2>
      
      <p className="text-sm text-muted-foreground">
        Última atualização: 02 de setembro de 2025
      </p>
      
      <p>
        Estes Termos de Uso ("Termos") regulam o acesso e a utilização da plataforma Justiçai ("Plataforma"), 
        desenvolvida e mantida pela Octopus Group – CNPJ 34.997.786/0001-85 ("Octopus Group"), responsável legal por sua operação.
      </p>
      
      <p>
        Ao acessar ou utilizar a Plataforma, o usuário declara ter lido, compreendido e concordado integralmente com os 
        presentes Termos. Caso não concorde, deve interromper imediatamente o uso.
      </p>
      
      <section>
        <h3 className="text-md font-medium mb-2">1. Descrição do Serviço</h3>
        <p>
          A Plataforma Justiçai, apoiada na tecnologia proprietária Laib e em integrações com inteligências artificiais 
          de terceiros, é destinada a auxiliar profissionais da área jurídica em suas atividades. Entre as funcionalidades 
          oferecidas, destacam-se:
        </p>
        <p className="mt-2">• Respostas a consultas jurídicas;</p>
        <p className="mt-1">• Pesquisa de jurisprudência;</p>
        <p className="mt-1">• Auxílio na redação e revisão de documentos legais;</p>
        <p className="mt-1">• Apoio na gestão de informações jurídicas.</p>
        <p className="mt-2">
          A IA principal da Plataforma é a Laib, desenvolvida pela Octopus Group. Podem ser utilizadas, de forma complementar, 
          soluções de terceiros, como Google, OpenAI, Claude, Grok, Deepseek e Perplexity.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">2. Uso da Plataforma</h3>
        <p>
          2.1. O Justiçai constitui ferramenta de apoio. Não substitui, em hipótese alguma, a atuação profissional de advogados 
          regularmente inscritos na OAB ou de outros profissionais jurídicos habilitados.
        </p>
        <p className="mt-2">
          2.2. O usuário compromete-se a utilizar a Plataforma apenas para fins lícitos, em conformidade com estes Termos, 
          a legislação brasileira e princípios éticos aplicáveis ao exercício da advocacia e demais áreas do Direito.
        </p>
        <p className="mt-2">
          2.3. É vedada a utilização da Plataforma para:
        </p>
        <p className="mt-1 ml-4">• Fins ilegais, fraudulentos ou que violem direitos de terceiros;</p>
        <p className="mt-1 ml-4">• Extração massiva de dados, engenharia reversa, revenda ou exploração não autorizada dos serviços;</p>
        <p className="mt-1 ml-4">• Inserção de informações falsas, ilícitas ou que comprometam a integridade da Plataforma.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">3. Registro e Conta do Usuário</h3>
        <p>
          3.1. Alguns recursos da Plataforma exigem a criação de conta individual.
        </p>
        <p className="mt-2">
          3.2. O usuário é exclusivamente responsável pela confidencialidade de suas credenciais de acesso, bem como por 
          toda atividade realizada sob sua conta.
        </p>
        <p className="mt-2">
          3.3. O usuário deve notificar imediatamente a Octopus Group em caso de uso não autorizado ou suspeita de violação de segurança.
        </p>
        <p className="mt-2">
          3.4. A Octopus Group não se responsabiliza por danos resultantes do uso indevido ou não autorizado da conta.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">4. Limitações de Responsabilidade</h3>
        <p>
          4.1. As informações geradas pela Plataforma têm caráter auxiliar e podem não ser completas, precisas ou atualizadas.
        </p>
        <p className="mt-2">
          4.2. A Octopus Group e a Plataforma Justiçai não se responsabilizam por decisões, atos ou omissões praticados com base 
          nos resultados apresentados.
        </p>
        <p className="mt-2">
          4.3. O usuário reconhece que algoritmos de inteligência artificial estão sujeitos a falhas, vieses e limitações técnicas, 
          devendo sempre validar os resultados com pesquisa jurídica própria e/ou orientação profissional adequada.
        </p>
        <p className="mt-2">
          4.4. O uso da Plataforma não estabelece relação advogado-cliente entre a Octopus Group e o usuário.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">5. Propriedade Intelectual</h3>
        <p>
          5.1. Todo o conteúdo disponibilizado na Plataforma, incluindo textos, logotipos, marcas, gráficos, ícones, imagens, 
          sons, vídeos, compilações de dados, software e códigos, é de propriedade da Octopus Group ou de seus licenciadores, 
          estando protegido pela legislação brasileira e tratados internacionais de direito autoral, propriedade industrial 
          e concorrência desleal.
        </p>
        <p className="mt-2">
          5.2. É vedada a reprodução, modificação, distribuição, comercialização, exibição pública ou exploração de qualquer 
          conteúdo da Plataforma sem autorização expressa e por escrito da Octopus Group.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">6. Privacidade e Proteção de Dados</h3>
        <p>
          6.1. O tratamento de dados pessoais na Plataforma é regulado pela Política de Privacidade e pelas diretrizes da 
          LGPD (Lei nº 13.709/2018).
        </p>
        <p className="mt-2">
          6.2. O usuário declara ciência de que o uso da Plataforma implica na coleta e processamento de informações necessárias 
          para seu funcionamento, conforme descrito na Política de Privacidade.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">7. Alterações dos Termos</h3>
        <p>
          7.1. A Octopus Group reserva-se o direito de alterar estes Termos a qualquer tempo.
        </p>
        <p className="mt-2">
          7.2. Alterações entrarão em vigor imediatamente após a publicação na Plataforma.
        </p>
        <p className="mt-2">
          7.3. O uso continuado da Plataforma após a atualização constitui aceite tácito das novas condições.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">8. Rescisão e Suspensão</h3>
        <p>
          8.1. A Octopus Group poderá, a seu critério exclusivo, suspender ou encerrar o acesso do usuário à Plataforma, 
          a qualquer momento, caso seja verificada:
        </p>
        <p className="mt-1 ml-4">• Violação destes Termos;</p>
        <p className="mt-1 ml-4">• Uso indevido ou ilícito;</p>
        <p className="mt-1 ml-4">• Adoção de condutas que possam prejudicar a segurança, integridade ou imagem da Plataforma e da Octopus Group.</p>
        <p className="mt-2">
          8.2. O encerramento da conta não afasta a responsabilidade do usuário por eventuais danos causados.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">9. Disposições Gerais</h3>
        <p>
          9.1. Estes Termos constituem o acordo integral entre o usuário e a Octopus Group em relação ao uso da Plataforma.
        </p>
        <p className="mt-2">
          9.2. Se qualquer cláusula destes Termos for considerada inválida ou inexequível, as disposições remanescentes 
          permanecerão em pleno vigor.
        </p>
        <p className="mt-2">
          9.3. A tolerância quanto ao descumprimento de qualquer cláusula não implicará renúncia ou novação.
        </p>
        <p className="mt-2">
          9.4. Estes Termos são regidos pelas leis da República Federativa do Brasil. Eventuais controvérsias serão 
          resolvidas exclusivamente perante o foro da Comarca de São Leopoldo/RS, com renúncia a qualquer outro, por 
          mais privilegiado que seja.
        </p>
      </section>
    </div>
  );
};

export default TermsOfUseContent;
